import React, { useEffect, useState } from 'react';
import GoogleMapReact from 'google-map-react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import axios from 'axios';

const GgMap = ({ currentCoord, setCarParkingLocation }) => {
  const [selectedLocation, setSelectedLocation] = useState({
    lat: currentCoord?.lat || 0,
    lng: currentCoord?.lng || 0
  });

  useEffect(() => {
    if (currentCoord) {
      setSelectedLocation(currentCoord);
    }
  }, [currentCoord]);

  const handleMapClick = (obj) => {
    // const { lat, lng } = obj;
    // setSelectedLocation({ lat, lng });

    // axios.get(`https://nominatim.openstreetmap.org/reverse.php?lat=${lat}&lon=${lng}&zoom=17&format=jsonv2`)
    //   .then((response) => {
    //     setCarParkingLocation({lat, lng, address: response.data.display_name})
    //   })
    //   .catch(err => {
    //     console.log(`⚡️[log]: †††††† ~ err: `, err);
    //   })
  };

  return (
    <div style={{ height: '400px', width: '100%' }}>
      <GoogleMapReact
        onClick={handleMapClick}
        // bootstrapURLKeys={{ key: GOOGLE_MAP_API_KEY, libraries:['places'] }}
        center={{ lat: currentCoord.lat || -21.16477048911468, lng: currentCoord.lng || 135.8886668086052 }}
        defaultZoom={12}
      >
        {selectedLocation && (
          <Marker lat={selectedLocation.lat} lng={selectedLocation.lng} />
        )}
      </GoogleMapReact>
    </div>
  );
};

const Marker = () => <div style={{ color: 'red' }}>
  <LocationOnIcon />
</div>;

export default GgMap;